'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Code = exports.Menugroup = exports.Caption = exports.Body2 = exports.Body1 = exports.Subheading = exports.Title = exports.Headline = exports.Display4 = exports.Display3 = exports.Display2 = exports.Display1 = exports['default'] = exports.styleSheet = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _class2, _temp2, _class3, _temp3, _class4, _temp4, _class5, _temp5, _class6, _temp6, _class7, _temp7, _class8, _temp8, _class9, _temp9, _class10, _temp10, _class11, _temp11, _class12, _temp12, _class13, _temp13;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = require('jss-theme-reactor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('Text', function (theme) {
  var mixins = theme.mixins,
      typography = theme.typography;

  return {
    root: { margin: 0 },
    body1: typography.body1,
    body2: typography.body2,
    caption: typography.caption,
    code: typography.code,
    headline: typography.headline,
    menugroup: typography.menugroup,
    title: typography.title,
    subheading: typography.subheading,
    display1: typography.display1,
    display2: typography.display2,
    display3: typography.display3,
    display4: typography.display4,
    highlight: typography.highlight,
    disabled: typography.disabled,
    error: typography.error,
    success: typography.success,
    paragraph: typography.paragraph,
    secondary: typography.secondary,
    gutters: mixins.gutters(1),
    colorInherit: { color: 'inherit' },
    noWrap: theme.mixins.truncate()
  };
});

var types = {
  body1: {},
  body2: {},
  caption: {},
  code: { component: 'code' },
  display1: { component: 'div' },
  display2: { component: 'div' },
  display3: { component: 'div' },
  display4: { component: 'div' },
  heading6: { component: 'h6' },
  headline: { component: 'h2' },
  menugroup: {},
  subheading: { component: 'div' },
  title: { component: 'h1' }
};
// eslint-disable-next-line react/display-name
var Text = (_temp = _class = function (_PureComponent) {
  _inherits(Text, _PureComponent);

  function Text() {
    _classCallCheck(this, Text);

    return _possibleConstructorReturn(this, (Text.__proto__ || Object.getPrototypeOf(Text)).apply(this, arguments));
  }

  _createClass(Text, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames;

        var _types$props$type$pro = Object.assign({}, types[this.props.type], this.props),
            children = _types$props$type$pro.children,
            classNameProp = _types$props$type$pro.className,
            colorInherit = _types$props$type$pro.colorInherit,
            component = _types$props$type$pro.component,
            componentRef = _types$props$type$pro.componentRef,
            disabled = _types$props$type$pro.disabled,
            error = _types$props$type$pro.error,
            gutters = _types$props$type$pro.gutters,
            highlight = _types$props$type$pro.highlight,
            noWrap = _types$props$type$pro.noWrap,
            paragraph = _types$props$type$pro.paragraph,
            secondary = _types$props$type$pro.secondary,
            success = _types$props$type$pro.success,
            type = _types$props$type$pro.type,
            props = _objectWithoutProperties(_types$props$type$pro, ['children', 'className', 'colorInherit', 'component', 'componentRef', 'disabled', 'error', 'gutters', 'highlight', 'noWrap', 'paragraph', 'secondary', 'success', 'type']);

        var classes = this.context.styleManager.render(styleSheet);

        var className = (0, _classnames2['default'])(classes.root, classes[type], (_classNames = {}, _defineProperty(_classNames, classes.secondary, secondary), _defineProperty(_classNames, classes.highlight, highlight), _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.gutters, gutters), _defineProperty(_classNames, classes.paragraph, paragraph), _defineProperty(_classNames, classes.error, error), _defineProperty(_classNames, classes.success, success), _defineProperty(_classNames, classes.colorInherit, colorInherit), _defineProperty(_classNames, classes.noWrap, noWrap), _classNames), classNameProp);

        var ref = typeof componentRef === 'function' && {
          ref: function () {
            function ref(c) {
              return componentRef(c);
            }

            return ref;
          }()
        };

        return _react2['default'].createElement(component, Object.assign({}, props, ref, {
          disabled: disabled,
          className: className
        }), children);
      }

      return render;
    }()
  }]);

  return Text;
}(_react.PureComponent), _class.propTypes = {
  /**
   * If `true`, the text will use the parent element's color.
   */
  colorInherit: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's disabled color.
   */
  disabled: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's error color.
   */
  error: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's success color.
   */
  success: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use default gutters.
   */
  gutters: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's highlight color.
   */
  highlight: _PropTypes2['default'].bool,
  /**
   * If `false`, the text will wrap
   */
  noWrap: _PropTypes2['default'].bool,
  /**
   * If `true`, padding will be added to the bottom of the container
   */
  paragraph: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's secondary color.
   */
  secondary: _PropTypes2['default'].bool,
  /**
   * Type of text area
   */
  type: _PropTypes2['default'].oneOf(Object.keys(types))
}, _class.defaultProps = {
  colorInherit: false,
  component: 'p',
  disabled: false,
  error: false,
  highlight: false,
  noWrap: false,
  paragraph: false,
  secondary: false,
  success: false,
  type: 'body1'
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp);
exports['default'] = Text;
var Display1 = exports.Display1 = (_temp2 = _class2 = function (_Text) {
  _inherits(Display1, _Text);

  function Display1() {
    _classCallCheck(this, Display1);

    return _possibleConstructorReturn(this, (Display1.__proto__ || Object.getPrototypeOf(Display1)).apply(this, arguments));
  }

  return Display1;
}(Text), _class2.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'display1'
}), _temp2);
var Display2 = exports.Display2 = (_temp3 = _class3 = function (_Text2) {
  _inherits(Display2, _Text2);

  function Display2() {
    _classCallCheck(this, Display2);

    return _possibleConstructorReturn(this, (Display2.__proto__ || Object.getPrototypeOf(Display2)).apply(this, arguments));
  }

  return Display2;
}(Text), _class3.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'display2'
}), _temp3);
var Display3 = exports.Display3 = (_temp4 = _class4 = function (_Text3) {
  _inherits(Display3, _Text3);

  function Display3() {
    _classCallCheck(this, Display3);

    return _possibleConstructorReturn(this, (Display3.__proto__ || Object.getPrototypeOf(Display3)).apply(this, arguments));
  }

  return Display3;
}(Text), _class4.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'display3'
}), _temp4);
var Display4 = exports.Display4 = (_temp5 = _class5 = function (_Text4) {
  _inherits(Display4, _Text4);

  function Display4() {
    _classCallCheck(this, Display4);

    return _possibleConstructorReturn(this, (Display4.__proto__ || Object.getPrototypeOf(Display4)).apply(this, arguments));
  }

  return Display4;
}(Text), _class5.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'display4'
}), _temp5);
var Headline = exports.Headline = (_temp6 = _class6 = function (_Text5) {
  _inherits(Headline, _Text5);

  function Headline() {
    _classCallCheck(this, Headline);

    return _possibleConstructorReturn(this, (Headline.__proto__ || Object.getPrototypeOf(Headline)).apply(this, arguments));
  }

  return Headline;
}(Text), _class6.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'headline'
}), _temp6);
var Title = exports.Title = (_temp7 = _class7 = function (_Text6) {
  _inherits(Title, _Text6);

  function Title() {
    _classCallCheck(this, Title);

    return _possibleConstructorReturn(this, (Title.__proto__ || Object.getPrototypeOf(Title)).apply(this, arguments));
  }

  return Title;
}(Text), _class7.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'title'
}), _temp7);
var Subheading = exports.Subheading = (_temp8 = _class8 = function (_Text7) {
  _inherits(Subheading, _Text7);

  function Subheading() {
    _classCallCheck(this, Subheading);

    return _possibleConstructorReturn(this, (Subheading.__proto__ || Object.getPrototypeOf(Subheading)).apply(this, arguments));
  }

  return Subheading;
}(Text), _class8.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'subheading'
}), _temp8);
var Body1 = exports.Body1 = (_temp9 = _class9 = function (_Text8) {
  _inherits(Body1, _Text8);

  function Body1() {
    _classCallCheck(this, Body1);

    return _possibleConstructorReturn(this, (Body1.__proto__ || Object.getPrototypeOf(Body1)).apply(this, arguments));
  }

  return Body1;
}(Text), _class9.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'body1'
}), _temp9);
var Body2 = exports.Body2 = (_temp10 = _class10 = function (_Text9) {
  _inherits(Body2, _Text9);

  function Body2() {
    _classCallCheck(this, Body2);

    return _possibleConstructorReturn(this, (Body2.__proto__ || Object.getPrototypeOf(Body2)).apply(this, arguments));
  }

  return Body2;
}(Text), _class10.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'body2'
}), _temp10);
var Caption = exports.Caption = (_temp11 = _class11 = function (_Text10) {
  _inherits(Caption, _Text10);

  function Caption() {
    _classCallCheck(this, Caption);

    return _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).apply(this, arguments));
  }

  return Caption;
}(Text), _class11.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'caption'
}), _temp11);
var Menugroup = exports.Menugroup = (_temp12 = _class12 = function (_Text11) {
  _inherits(Menugroup, _Text11);

  function Menugroup() {
    _classCallCheck(this, Menugroup);

    return _possibleConstructorReturn(this, (Menugroup.__proto__ || Object.getPrototypeOf(Menugroup)).apply(this, arguments));
  }

  return Menugroup;
}(Text), _class12.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'menugroup'
}), _temp12);
var Code = exports.Code = (_temp13 = _class13 = function (_Text12) {
  _inherits(Code, _Text12);

  function Code() {
    _classCallCheck(this, Code);

    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
  }

  return Code;
}(Text), _class13.defaultProps = Object.assign({}, Text.defaultProps, {
  type: 'code'
}), _temp13);


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Text/index.js
// module id = 56
// module chunks = 32